import React from 'react';
import { isEmpty } from '@docavenue/core';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { useRouter } from 'next/router';
import { cn } from '@kiiwi/ui';
import { analyticsEvent } from '@/src/analytic_tag_manager';
import { getPictureSource } from '../../utils/card';
import { Avatar } from '@/components/ui/not-existing-kiiwi-components/Avatar';

interface Props {
  item: CardHcd;
  onClick: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
  size?: 'xs' | 'sm';
}

const SearchCardAvatar: React.FC<Props> = ({ item, onClick, size = 'sm' }) => {
  const { pathname } = useRouter();
  const substitute = item?.substituteData;
  let avatarSource =
    item.type === 'CENTER' && !getPictureSource(item)
      ? '/static/images/default_center.svg'
      : getPictureSource(item);

  if (!isEmpty(substitute) && pathname.includes('teleconsultation')) {
    avatarSource = '/static/images/avatar-substitute.svg';
  }

  if (!avatarSource) {
    avatarSource = `/static/images/default_practitioner.svg`;
  }

  const onAvatarClick = React.useCallback(
    (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
      analyticsEvent({
        category: 'PractitionersAndCentersResults',
        action: 'ClickCardPicture',
      });

      onClick(e);
    },
    [onClick],
  );

  return (
    <Avatar
      src={avatarSource}
      className={cn(
        'cursor-pointer',
        size === 'xs' && 'h-[40px] w-[40px]',
        size === 'sm' && 'h-[72px] w-[72px]',
      )}
      onClick={onAvatarClick}
    />
  );
};

export default SearchCardAvatar;
